import { z } from 'zod';

/////////////////////////////////////////
// PAYMENTS TRANSACTIONS SCHEMA
/////////////////////////////////////////

export const PaymentsTransactionsSchema = z.object({
  id: z.bigint(),
  city_id: z.number().int().nullable(),
  user_id: z.number().int().nullable(),
  amount: z.number().int().nullable(),
  amount_received: z.number().int().nullable(),
  transaction_id: z.string().nullable(),
  gogov_object_id: z.string().nullable(),
  data: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  deleted_at: z.coerce.date().nullable(),
  method: z.string().nullable(),
  confirmed_at: z.coerce.date().nullable(),
  source: z.string().nullable(),
  stripe_event_type: z.string().nullable(),
  parent_id: z.number().int().nullable(),
  type: z.string().nullable(),
  status: z.string().nullable(),
  stripe_status: z.string().nullable(),
  convenience_fee_in_cents: z.number().int().nullable(),
  main_amount: z.number().int().nullable(),
  comment: z.string().nullable(),
  net_profit: z.number().int().nullable(),
  payout_id: z.bigint().nullable(),
  balance_transaction: z.string().nullable(),
  idempotency_key: z.string().nullable(),
  client_secret: z.string().nullable(),
  stripe_mode: z.string().nullable(),
  last4: z.string().nullable(),
  card_network: z.string().nullable(),
  category: z.string().nullable(),
  respond_by: z.coerce.date().nullable(),
  cash_register_id: z.number().int().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type PaymentsTransactions = z.infer<typeof PaymentsTransactionsSchema>

export default PaymentsTransactionsSchema;
